import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
declare var bootstrap: any;

@Component({
  selector: 'app-producto',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './producto.html',
  styleUrls: ['./producto.scss'],
})
export class Producto implements OnInit {
  // Propiedades para la búsqueda
  searchQuery: string = '';
  mostrarResultados: boolean = false;
  productosFiltrados: any[] = [];
  searchHover: boolean = false;

  // Variables para el modal móvil
  selectedMobileImage: string = '';
  selectedProductThumbnails: string[] = [];
  selectedImage: string | null = null;

  // URL base de tu CDN
  private cdnBaseUrl = 'https://ragde39.github.io/cdn_es/productos';

  // Array de productos con las carpetas reales del CDN
  productos = [
    {
      id: 1,
      name: 'Almohada',
      folder: 'almohada',
      desc: 'Almohadas ergonómicas de alta calidad para un descanso perfecto',
    },
    {
      id: 2,
      name: 'Carpas',
      folder: 'carpas',
      desc: 'Carpas resistentes para camping, carros y actividades al aire libre',
    },
    {
      id: 3,
      name: 'Colchón',
      folder: 'colchon',
      desc: 'Colchones ortopédicos de diferentes medidas y materiales',
    },
    {
      id: 4,
      name: 'Colchonetas',
      folder: 'colchonetas',
      desc: 'Colchonetas para gimnasia, yoga y descanso',
    },
    {
      id: 5,
      name: 'Parasoles',
      folder: 'parasoles',
      desc: 'Parasoles para playa, jardín y exteriores',
    },
    {
      id: 6,
      name: 'Parques',
      folder: 'parques',
      desc: 'Parques infantiles para diversión y entretenimiento',
    },
    { id: 7, name: 'Puff', folder: 'puff', desc: 'Puffs cómodos y modernos para tu hogar' },
    {
      id: 8,
      name: 'Saltarín',
      folder: 'saltarin',
      desc: 'Saltarín infantil para diversión y ejercicio',
    },
    {
      id: 9,
      name: 'Tapicería',
      folder: 'tapiceria',
      desc: 'Tapicería especializada para muebles y vehículos',
    },
  ].map((item) => ({
    id: item.id,
    title: item.name,
    folderName: item.folder,
    mainImage: `${this.cdnBaseUrl}/${item.folder}/thumbnails6.png`,
    thumbnails: Array(6)
      .fill(0)
      .map((_, j) => `${this.cdnBaseUrl}/${item.folder}/thumbnails${j + 1}.png`),
    description: item.desc,
  }));

  constructor(private router: Router, private titleService: Title, private metaService: Meta) {}

  ngOnInit(): void {
    // SEO dinámico
    this.titleService.setTitle('Pegaespumas | Productos');
    this.metaService.updateTag({
      name: 'description',
      content:
        'Explora nuestra variedad de espumas de alta calidad para colchones, tapicería, parques infantiles, saltarines, carpas y parasoles en Colombia.',
    });

    // Inicializar productos filtrados con todos los productos
    this.productosFiltrados = [...this.productos];
  }

  contactar(productoId: number) {
    this.router.navigate(['/contacto'], { state: { productoId } });
  }

  // Método para abrir el modal en móviles
  openMobileModal(producto: any) {
    if (window.innerWidth <= 768) {
      this.selectedMobileImage = producto.mainImage;
      this.selectedProductThumbnails = producto.thumbnails;

      const modalElement = document.getElementById('mobileImageModal');
      if (modalElement) {
        const modal = new (window as any).bootstrap.Modal(modalElement);
        modal.show();
      }
    }
  }

  // Método para cambiar imagen en el modal móvil
  changeMobileImage(newImage: string) {
    this.selectedMobileImage = newImage;
  }

  // Función para cambiar la imagen principal
  cambiarImagenPrincipal(producto: any, nuevaImagen: string, event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    producto.mainImage = nuevaImagen;

    if (window.innerWidth <= 768 && this.selectedMobileImage) {
      this.selectedMobileImage = nuevaImagen;
    }
  }

  // Función para filtrar productos basado en la búsqueda
  filtrarProductos() {
    if (!this.searchQuery.trim()) {
      this.productosFiltrados = [...this.productos];
    } else {
      const query = this.searchQuery.toLowerCase().trim();
      this.productosFiltrados = this.productos.filter((producto) => {
        const titulo = producto.title.toLowerCase();
        const descripcion = producto.description.toLowerCase();
        const folderName = producto.folderName.toLowerCase();

        return (
          titulo.includes(query) ||
          descripcion.includes(query) ||
          folderName.includes(query) ||
          producto.id.toString().includes(query)
        );
      });
    }
    this.mostrarResultados = true;
  }

  onSearchBlur() {
    if (!this.searchHover) {
      setTimeout(() => {
        this.mostrarResultados = false;
      }, 200);
    }
  }

  onSearchMouseEnter() {
    this.searchHover = true;
  }

  onSearchMouseLeave() {
    this.searchHover = false;
    setTimeout(() => {
      if (!this.searchHover) {
        this.mostrarResultados = false;
      }
    }, 300);
  }

  preventBlur(event: Event) {
    event.preventDefault();
  }

  scrollToProduct(productoId: number) {
    this.mostrarResultados = false;
    this.searchQuery = '';

    const element = document.getElementById(`producto-${productoId}`);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
      element.classList.add('product-highlight');
      setTimeout(() => {
        element.classList.remove('product-highlight');
      }, 2000);
    }
  }

  abrirModalImagen(imagen: string) {
    this.selectedImage = imagen;
    const modal = new bootstrap.Modal(document.getElementById('imagenModal')!);
    modal.show();
  }
}
